import { writable } from "svelte/store"

export const MediaDragStore = writable<{
	id: number
}>()

export function setMediaDrag(id) {
	MediaDragStore.set({ id })
}

export function clearMediaDrag() {
	MediaDragStore.set(undefined)
}
